import { render, staticRenderFns } from "./HomeTeacher.vue?vue&type=template&id=dce43660&"
import script from "./HomeTeacher.vue?vue&type=script&lang=js&"
export * from "./HomeTeacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports